import React, { useState } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { EditableFormula, TabLabel, Variants } from '@/features';
import palette from '@/theme/palette.ts';

export const ProductPossibleModificationsUtil = () => {
  const { t } = useTranslation();
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const { id } = useParams<{ id: string }>();
  const queryClient = useQueryClient();

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTabIndex(newValue);
    queryClient.invalidateQueries({ queryKey: ['productIngredients', Number(id)] });
  };

  return (
    <Stack direction="column" gap={2} sx={{ '.MuiTableCell-body': { padding: '8px' } }}>
      <Box sx={{ borderBottom: 1, borderColor: palette.text.tertiary }}>
        <Tabs
          value={currentTabIndex}
          onChange={handleChange}
          textColor="inherit"
          sx={{
            '& .MuiTypography-root': { textTransform: 'none', fontWeight: 500, fontSize: '14px' },
            '& .MuiButtonBase-root': { padding: '0', marginRight: '24px' },
          }}
        >
          <Tab
            label={
              <TabLabel
                icon={<span className="material-symbols-rounded">list</span>}
                label={t('INGREDIENT.FORMULA')}
              />
            }
          />
          <Tab
            label={
              <TabLabel
                icon={<span className="material-symbols-rounded">tune</span>}
                label={t('VARIANT.VARIANTS')}
              />
            }
          />
        </Tabs>
      </Box>
      <Box role="tabpanel" hidden={currentTabIndex !== 0}>
        {currentTabIndex === 0 && <EditableFormula key={currentTabIndex} />}
      </Box>
      <Box role="tabpanel" hidden={currentTabIndex !== 1}>
        {currentTabIndex === 1 && <Variants key={currentTabIndex} />}
      </Box>
    </Stack>
  );
};
